export enum SkinClashRoundStatus {
  WAITING = 0,
  ACTIVE = 10,
  PICKING = 20,
  COMPLETED = 30,
  CANCELLED = 40,
  ERROR = 50,
}

export enum SkinClashItemDisposition {
  PENDING = 0,
  WINNER_PAYOUT = 10,
  FEE = 20,
  REFUNDED = 30,
}

export interface SkinClashConfig {
  roundDurationSeconds: number
  minDistinctUsersToStart: number
  feeBps: number
  minItemPriceCents: number
  maxItemPriceCents: number
  maxItemsPerEntry: number
  maxEntryValueCents: number
  lossBonusXpPercent: number
  maxLossBonusXp: number
}

export interface SkinClashFairness {
  algorithm: string
  serverSeedHash: string
  serverSeed: string | null
  entrySnapshotHash: string | null
  totalTickets: number
  winningTicket: number | null
  revealedAt: string | null
}

export interface SkinClashItem {
  id: string
  inventoryItemId: string
  itemId: string
  entryId: string
  userId: string
  price: number
  disposition: SkinClashItemDisposition
  name: string
  weapon: string | null
  skin: string | null
  exterior: string | null
  rarity: string | null
  color: string | null
  image: string | null
  stattrak: boolean
}

export interface SkinClashEntry {
  id: string
  userId: string
  userName: string
  userAvatar: string | null
  value: number
  ticketStart: number
  ticketEnd: number
  ticketCount: number
  baseXp: number
  lossBonusXp: number
  createdAt: string
  items: SkinClashItem[]
}

export interface SkinClashRound {
  id: string
  roundNumber: number
  status: SkinClashRoundStatus
  totalValue: number
  totalTickets: number
  feeBps: number
  targetFee: number
  feeAmount: number
  winnerUserId: string | null
  winningEntryId: string | null
  winningTicket: number | null
  startsAt: string | null
  endsAt: string | null
  completedAt: string | null
  fairness: SkinClashFairness
  entries: SkinClashEntry[]
  items: SkinClashItem[]
  config: SkinClashConfig
}

export interface SkinClashCurrentResponse {
  success: boolean
  data?: {
    round: SkinClashRound | null
  }
  error?: string
}

export interface SkinClashHistoryResponse {
  success: boolean
  data?: {
    rounds: SkinClashRound[]
  }
  error?: string
}

export interface SkinClashJoinRequest {
  inventoryItemIds: string[]
}

export interface SkinClashJoinResponse {
  success: boolean
  error?: string
  data?: {
    round: SkinClashRound
    entry: SkinClashEntry
  }
}

export const SKIN_CLASH_DEFAULT_CONFIG: SkinClashConfig = {
  roundDurationSeconds: 60,
  minDistinctUsersToStart: 2,
  feeBps: 1000,
  minItemPriceCents: 10,
  maxItemPriceCents: 70_000,
  maxItemsPerEntry: 10,
  maxEntryValueCents: 70_000,
  lossBonusXpPercent: 10,
  maxLossBonusXp: 5000,
}
